<template>
  <div>
    <input v-show="!showAddBlock" @click="showAddBlock = !showAddBlock" class="add-comment-input" placeholder="Write a comment" type="text">
    <div v-show="showAddBlock" class="addBlock">
      <textarea class="add-comment-input h-120" placeholder="Write a comment" type="text" v-model="postContent"></textarea>
      <!-- <div class="tags-area">
        <span class="tags-text">Nota uygun etiketler</span>
        <div class="currentTag">
          <button class="btn tag-button" @click="changeTag('meeting_note')" :class="{active:currentTag=='meeting_note'}">Toplantı Notu</button>
          <button class="btn tag-button" @click="changeTag('phone_note')" :class="{active:currentTag=='phone_note'}">Telefon Notu</button>
          <button class="btn tag-button" @click="changeTag('correspondence')" :class="{active:currentTag=='correspondence'}">Yazışma</button>
          <button class="btn tag-button" @click="changeTag('deal')" :class="{active:currentTag=='deal'}">Pazarlık</button>
          <button class="btn tag-button" @click="changeTag('order')" :class="{active:currentTag=='order'}">Sipariş</button>
          <button class="btn tag-button" @click="changeTag('collection_call')" :class="{active:currentTag=='collection_call'}">Tahsilat Araması</button>
        </div>
      </div> -->
      <div class="row record-area pt-1">
        <div class="col-md-3">
          <select class="new-input bg-white px-0" @change="chooseRecord($event)">
            <option disabled selected value="">Kayıt Seç</option>
            <option value="file">Dosya/Fotoğraf Ekle</option>
            <option value="company">İlgili Şirket Ekle</option>
            <option value="contact">İlgili Kişi Ekle</option>
            <option value="deal">İlgili Satış Fırsatı Ekle</option>
          </select>
        </div>
        <div class="col-md-9 pl-0">
          <div class="related-tag-box">
            <div class="tag-box" v-for="(item, index) in tagsArray" :key="index" >
              <div class="d-flex align-items-center">
                <span>
                  {{ maxTextLength(item.name, 18)}}
                </span>
                <button type="button" class="close pl-2" @click="removeTag(item)">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="warn">
        <i class="fas fa-exclamation-circle"></i>
        <span>Nota eklemek istediğiniz kayıtları seçin. Seçimleriniz ilgili kayıtların sayfasına eklenecektir. </span>
      </div>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn bg-transparent mr-2" @click="closeBlock()">{{$ml.get('CANCEL')}}</button>
        <button type="button" class="btn bg-new-primary f-14 h-100 px-4" @click="addPostF()">
          {{$ml.get('SAVE')}}
        </button>   
      </div>  
    </div>
    
    <div class="modal fade" id="changeTagModal" tabindex="-1" aria-labelledby="changeTagModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title createProcessModalHeader" id="changeTagModalLabel">{{ modalHeader }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeButton()">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body pt-3 pb-5">
              <div class="row">
                  <div class="col-12">
                    <multiselect v-if="type!='file'" @search-change="quickSearchRecords($event)" v-model="value" tag-placeholder="Add this as new tag" label="name" track-by="name" :options="options" :multiple="true" :taggable="false" :close-on-select="false"></multiselect>
                    <input v-else type="file" class="file-input" @change="changedFileInput($event)">
                  </div>
              </div>
          </div>
          <div class="modal-footer noteBtnStyle">
            <button @click="closeButton()" type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
            <button @click="addRecord()" data-dismiss="modal" type="button" class="btn-new save ml-1">{{$ml.get('SAVE')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: "AddPost",
  components: {
    Multiselect
  },
  data() {
    return {
      showAddBlock: false,
      currentTag: "",
      value: [],
      options: [],
      tagsArray: [],
      modalHeader: "",
      url: "",
      type: "",
      fileInput: "",
      postContent: ""
    }
  },
  computed:{
    ...mapState([
      'baseUrl'
    ]),
    ...mapGetters(['ownerId']),
  },
  methods: {
    changeTag(tag) {
      this.currentTag = tag
    },
    chooseRecord(event) {
      if(event.target.value == 'company'){
        this.modalHeader = this.$ml.get('RELATED_COMPANY')
        this.url = "/quickFilterOrganization"
        this.type = "organizations"
        $('#changeTagModal').modal('show')
      }
      if(event.target.value == 'contact'){
        this.modalHeader = this.$ml.get('CONTACT_NAME')
        this.url = "/quickFilterContact"
        this.type = "contacts"
        $('#changeTagModal').modal('show')
      }
      if(event.target.value == 'deal'){
        this.modalHeader = this.$ml.get('OPPORTUNITY')
        this.url = "/quickFilterDeal"
        this.type = "deals"
        $('#changeTagModal').modal('show')
      }
      if(event.target.value == 'file'){
        this.modalHeader = this.$ml.get('SELECT_FILE')
        this.type = "file"
        $('#changeTagModal').modal('show')
      }
      
    },
    removeTag(item) {
      this.tagsArray.splice(this.tagsArray.findIndex(a => a._id === item._id) , 1)
    },
    changedFileInput(event) {
      this.fileInput = event.target.files[0]
    },
    quickSearchRecords(keyWord){
      var dataObj = {
        search:keyWord,
      }

      if(this.url == '/quickFilterDeal'){
        dataObj = {
          dealName:keyWord,
        }
      }

      axios({
        method:'POST',
        url:this.url,
        baseURL: this.baseUrl,
        data: dataObj,
        withCredentials:true
      }).then((res)=>{
        return res
      }).then((res)=>{
        if(!res.data.status){
          this.$router.push('/logout')
        }
        if(res.data.status.code==0){
          this.options = this.editData(res.data.content[this.type], this.type)
        }
      })
    },
    addPostF(){
      var params = {}
      params.author = localStorage.cuid
      params.content = this.postContent

      let obj = {}
      for(let item of this.tagsArray){
        if(item._id != undefined){
          obj[item._id.$oid] = item
        }
        else{
        }
      }
      params.related_tags = obj

      axios({
        method:'POST',
        url:'/addPost',
        baseURL: this.baseUrl,
        data: params,
        withCredentials:true
      }).then((res)=>{
        return res
      }).then((res)=>{
        if(!res.data.status){
          this.$router.push('/logout')
        }
        if(res.data.status.code==0){
          this.showAddBlock = false
          this.$root.$refs.posts.getPostsF()
          this.closeBlock()
        }
      })
    },
    editData(data, type) {
      let array = []
      if( type == 'contacts' ) {
        for( let element of data ) {
          let obj = {}
          obj._id = element._id
          obj.type = "contact"
          if(element.sn !== undefined){
            obj.name = element.n + " " + element.sn
          }
          else{
            obj.name = element.n + " "
          }
          array.push(obj)
        }
      }
      else if( type == 'deals') {
        for( let element of data ) {
          let obj = {}
          obj._id = element._id
          obj.type = "deal"
          obj.name = element.title
          array.push(obj)
        }
      }
      else{
        array = data
      }

      return array
    },
    addRecord() {
      if(this.type!= 'file'){
        for(let item of this.value){
          if (this.tagsArray.filter(e => e._id === item._id).length == 0) {
            item.type = this.type
            this.tagsArray.push(item)
          }
        }
      }
      else{
        this.tagsArray.push(this.fileInput)
      }
      this.closeButton()
    },
    closeButton() {
      $('#changeTagModal').modal('hide')
      this.modalHeader = ""
      this.value = []
      this.options = []
      this.url = ""
      this.type = ""
    },
    closeBlock() {
      this.showAddBlock = false
      this.tagsArray = []
      this.postContent = ""
      this.fileInput = ""
      this.closeButton()
    },
    maxTextLength:function(value,max){
      if ( value && value.length > max ) {
        return value.substring(0,max) + '...'
      } else {
        return value || ''
      }
    }
  }
}
</script>

<style>
  
  .add-comment-input {
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 4px;
    padding: 12px 8px;
    text-align: initial;
  }

  ::placeholder {
    font-size: 13px;
    color: rgba(68, 68, 68, 0.4);
  }

  .addBlock {
    padding: 8px;
    background: #EBEBEB;
    border-radius: 8px;
  }

  .h-120 {
    height: 120px;
  }

  .tags-area {
    display: flex;
    align-items: center;
    padding: 12px 0;
  }

  .currentTag {
    padding-left: 18px;
  }

  .currentTag .active {
    background: #8b8b8b;
    color: #fff;
  }

  .tags-text{
    font-size: 14px;
    color: #444444;
  }

  .tag-button {
    padding: 6px 15px;
    background: #C9C9C9;
    border-radius: 4px;
    height: 25px;
    text-align: center;
    font-size: 10px;
    line-height: 12px;
  }

  .new-input {
    background: #E8E8E8;
  }

  .warn  {
    padding: 8px 0;
    font-size: 12px;
  }

  .related-tag-box {
    background: #FFFFFF;
    max-width: 595px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    padding: 4px 8px;
    align-items: center;
  }

  .tag-box {
    padding: 8px;
    background: #62B587;
    margin-right: 6px;
    color: white;
    border-radius: 4px;
  }

  .close {
    font-size: 16px;
  }

  .close:focus{
    outline: none;
  }
  .file-input {
    width: 100%;
  }
</style>